// VFX: Problem vs Solution Cards
// Slug: ui_comparison-split_cards_1000ms
// Category: comparison
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;
type CompItem = { label: string; items: string[] };
type Props = { left?: CompItem; right?: CompItem; dark?: boolean };

const LEFT_DEFAULT: CompItem = {
  label: "× Antes",
  items: ["Depende de 1 pessoa", "Para quando você para", "Sem processo documentado"],
};
const RIGHT_DEFAULT: CompItem = {
  label: "✓ Depois",
  items: ["Sistema documentado", "Roda sem você", "Processo replicável"],
};

export default function UiComparisonSplitCards1000ms({
  left = LEFT_DEFAULT,
  right = RIGHT_DEFAULT,
  dark = true,
}: Props) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const leftP = spring({ frame, fps, config: { damping: 130, stiffness: 180 } });
  const rightP = spring({ frame: frame - 12, fps, config: { damping: 130, stiffness: 180 } });
  const bg = dark ? "#060608" : "#f8fafc";

  const renderCard = (data: CompItem, p: number, side: "left" | "right") => {
    const isRight = side === "right";
    const color = isRight ? "#34d399" : "#ef4444";
    const cardBg = dark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)";
    const textColor = dark ? "#f0f0f0" : "#1a1a2e";
    return (
      <div
        style={{
          flex: 1,
          opacity: p,
          transform: `translateX(${interpolate(p, [0, 1], [isRight ? 40 : -40, 0], clamp)}px)`,
          borderRadius: 16,
          overflow: "hidden",
          background: cardBg,
          border: `1px solid ${color}33`,
          boxShadow: `0 4px 20px rgba(0,0,0,0.3), 0 0 0 1px ${color}11`,
        }}
      >
        <div style={{ padding: "12px 18px", background: `${color}15`, borderBottom: `1px solid ${color}22` }}>
          <span style={{ fontSize: 16, fontWeight: 700, color, fontFamily: "system-ui" }}>{data.label}</span>
        </div>
        <div style={{ padding: "16px 18px", display: "flex", flexDirection: "column", gap: 12 }}>
          {data.items.map((item, i) => {
            const itemP = spring({ frame: frame - 18 - i * 8, fps, config: { damping: 160, stiffness: 200 } });
            return (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 10,
                  opacity: itemP,
                  transform: `translateX(${interpolate(itemP, [0, 1], [10, 0], clamp)}px)`,
                }}
              >
                <span style={{ color, flexShrink: 0, fontSize: 14, marginTop: 2 }}>{isRight ? "✓" : "×"}</span>
                <span style={{ fontSize: 14, color: textColor, fontFamily: "system-ui", lineHeight: 1.4 }}>{item}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <AbsoluteFill style={{ background: bg, justifyContent: "center", alignItems: "center", padding: "0 30px" }}>
      <div style={{ display: "flex", gap: 16, width: "100%" }}>
        {renderCard(left, leftP, "left")}
        {renderCard(right, rightP, "right")}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
